module.exports = __webpack_public_path__ + "img/6.ed031bb8.png";